export const colorsChartDefault = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    gray: {
        medium: { light: "rgba(206, 215, 222, 1)" }
    },
    black: {
        petroleum: {
            light: "rgba(6, 50, 84, 1)",
            dark: "rgba(81, 107, 158, 1)"
        },
        medium: { light: "rgba(0, 0, 0, 1)" },
        light: { light: "rgba(0, 0, 0, 0)" },
        lightness: {
            light: "rgba(0, 0, 0, 0.2)",
            dark: "rgba(255, 255, 255, 0.33)"
        }
    },
    white: {
        light: { light: "rgba(255, 255, 255, 0.33)" },
        medium: { light: "rgba(255, 255, 255, 1)" }
    },
    basic: {
        darkside: { light: "rgba(0, 27, 47, 1)" },
        darker: { light: "rgba(6, 50, 84, 1)" },
        dark: { light: "rgba(46, 85, 115, 1)", dark: "rgba(81, 107, 158, 1)" },
        medium: { light: "rgba(92, 126, 153, 1)" },
        light: { light: "rgba(153, 182, 204, 1)" },
        lighter: { light: "rgba(207, 219, 230, 1)" },
        "darker-died": { light: "rgba(46, 85, 115, .9)" }
    },
    purple: {
        darker: {
            light: "rgba(149, 0, 179, 1)",
            dark: "rgba(163, 113, 247, 1)"
        },
        dark: { light: "rgba(181, 0, 217, 1)", dark: "rgba(163, 19, 191, 1)" },
        medium: {
            light: "rgba(213, 0, 255, 1)",
            dark: "rgba(200, 81, 225, 1)"
        },
        light: {
            light: "rgba(230, 102, 255, 1)",
            dark: "rgba(210, 115, 230, 1)"
        },
        lighter: {
            light: "rgba(240, 166, 255, 1)",
            dark: "rgba(220, 172, 230, 1)"
        }
    },
    magenta: {
        darker: { light: "rgba(179, 0, 110, 1)", dark: "rgba(179, 0, 110, 1)" },
        dark: { light: "rgba(217, 0, 134, 1)", dark: "rgba(219, 97, 162, 1)" },
        medium: {
            light: "rgba(255, 0, 157, 1)",
            dark: "rgba(230, 23, 150, 1)"
        },
        light: {
            light: "rgba(255, 102, 196, 1)",
            dark: "rgba(230, 115, 186, 1)"
        },
        lighter: {
            light: "rgba(255, 153, 216, 1)",
            dark: "rgba(230, 161, 203, 1)"
        }
    },
    yellow: {
        darker: {
            light: "rgba(230, 126, 0, 1)",
            dark: "rgba(240, 136, 62, 1)"
        },
        dark: { light: "rgba(255, 183, 0, 1)", dark: "rgba(227, 179, 65, 1)" },
        medium: {
            light: "rgba(255, 226, 0, 1)",
            dark: "rgba(230, 205, 23, 1)"
        },
        light: {
            light: "rgba(255, 237, 102, 1)",
            dark: "rgba(230, 216, 115, 1)"
        },
        lighter: {
            light: "rgba(255, 243, 153, 1)",
            dark: "rgba(230, 221, 161, 1)"
        }
    },
    cyan: {
        darker: {
            light: "rgba(0, 157, 162, 1)",
            dark: "rgba(16, 152, 173, 1)"
        },
        dark: { light: "rgba(0, 185, 191, 1)", dark: "rgba(15, 148, 153, 1)" },
        medium: {
            light: "rgba(0, 245, 255, 1)",
            dark: "rgba(23, 223, 230, 1)"
        },
        light: {
            light: "rgba(102, 250, 255, 1)",
            dark: "rgba(115, 226, 230, 1)"
        },
        lighter: {
            light: "rgba(153, 252, 255, 1)",
            dark: "rgba(153, 252, 255, 1)"
        },
        disabled: { light: "rgba(0, 210, 217, 0.33)" }
    },
    violet: {
        darker: { light: "rgba(78, 3, 137, 1)" },
        dark: { light: "rgba(134, 2, 197, 1)" },
        medium: { light: "rgba(213, 0, 255, 1)" },
        light: { light: "rgba(180, 21, 255, 1)" },
        lighter: { light: "rgba(204, 44, 231, 1)" },
        "light-weight": { light: "rgba(230, 156, 242, 1)" },
        "lighter-weight": { light: "rgba(237, 207, 255, 1)" }
    }
};
